<template>
  <!--
    AG-05 -- fila de "insertar todas las sugerencias del asistente" (ronda 24, reusable): el
    toggle "Seleccionar todas" a la izquierda + el botón de guardado masivo a la derecha. Antes
    esta fila (con su CSS) estaba duplicada tal cual en GoalsManager.vue y
    SubAreaNecessity.vue; ahora es un componente único que además usa SubAreaGoalCallout.vue
    (Objetivos). El componente es puramente presentacional -- toda la lógica de selección vive
    en aiBulkSelectMixin.js, del lado de quien lo usa.
  -->
  <div v-if="selectableCount > 0" class="ai-bulk-select-bar">
    <CustomCheckbox
      :value="allSelected"
      text="Seleccionar todas"
      class="ai-bulk-select-bar__toggle"
      @input="(val) => $emit('toggle-select-all', val)"
    />
    <button
      type="button"
      class="ai-bulk-select-bar__btn"
      :disabled="!selectedCount || disabled"
      @click="$emit('add-selected')"
    >
      <AiSparkIcon :size="11" variant="white" />
      Añadir seleccionadas ({{ selectedCount }})
    </button>
  </div>
</template>

<script>
import AiSparkIcon from './AiSparkIcon.vue';
import { CustomCheckbox } from '@/components/common';

export default {
  name: 'AiBulkSelectBar',
  components: {
    AiSparkIcon,
    CustomCheckbox,
  },
  props: {
    // Cuántas sugerencias vigentes son elegibles para selección masiva (ver
    // aiBulkSelectMixin.js -- aiBulkSelectableSuggestions). 0 = la fila no se pinta.
    selectableCount: {
      type: Number,
      default: 0,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    allSelected: {
      type: Boolean,
      default: false,
    },
    // true mientras el modal está en loading (generando/refinando/guardando) -- deshabilita el
    // botón igual que ya hacía cada copia local de esta fila.
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ai-bulk-select-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.ai-bulk-select-bar__toggle {
  width: auto;
  flex: 0 0 auto;
}

.ai-bulk-select-bar__toggle ::v-deep label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #4a5a53;
  cursor: pointer;
  white-space: nowrap;
}
.ai-bulk-select-bar__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  border-radius: 4px;
  padding: 6px 12px;
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  font-size: 12.5px;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #5c58ed;
  background: linear-gradient(104deg, #5c58ed 24.303%, #ba65ff 134.64%);
  color: #fff;
}

.ai-bulk-select-bar__btn:hover:not(:disabled) {
  background: linear-gradient(104deg, #4a45d6 24.303%, #a94dff 134.64%);
}

.ai-bulk-select-bar__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
